import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ZenplansTestDataProviderService } from './../../services/zenplans-test-data-provider.service';
import { UserInfoService } from './../../services/user-info.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  
  sectionTitle = "Login"
  SILogInNewAccount = {
    createAccount: "Don't have an account?",
    linkSignUp: 'Sign Up'
  }
  
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  authenticationService: any;
  alertService: any;
  id;
  loginFail:boolean=false;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private zenplansTestDataProviderService: ZenplansTestDataProviderService,
    private userInfo:UserInfoService) {}
    
  
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
        userName: ['', Validators.required],
        password: ['', Validators.required]
    });
  }
  get f() { return this.loginForm.controls; }
  async onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
        return;
    }

    //this.loading = true;
    this.id = await this.zenplansTestDataProviderService.checkPassword("users",
      this.loginForm.controls["userName"].value,this.loginForm.controls["password"].value
      );
      if(this.id){
        let myUser = await this.zenplansTestDataProviderService.getItem(this.id,"users");
        this.userInfo.changeMessage(JSON.stringify(myUser));
        this.router.navigate(['/home']);
      }
      else
      {
        this.loginFail = true;
      }
    // this.authenticationService.login(this.f.username.value, this.f.password.value)
    //     .pipe(first())
    //     .subscribe(
    //         data => {
    //             this.router.navigate([this.returnUrl]);
    //         },
    //         error => {
    //             this.alertService.error(error);
    //             this.loading = false;
    //         });
     }
}
